<div class="container mt-2 pb-4">

  <div class="row">
    <div class="betting-category mb-2">
      <div class="card-body px-0">
        <div class="d-flex">
          <div class="race-icon bordered mr-2">
            <span class="icon" style="color: #000;"
              [ngClass]="[kironResults[0]?.eventName.indexOf('Greyhound')!=-1 ? 'icon-greyhound':'icon-horse']"></span>
          </div>
          <div class="d-flex flex-column">
            <span class="t">Event {{kironResults[0]?.eventCode}} - {{kironResults[0]?.offTimeLocal}} </span>
            <span class="t-faded t-smaller">{{kironResults[0]?.eventName}}</span>
          </div>
          <div class="extra d-flex">
            <div class="d-flex flex-column align-items-end mt-2" style="color: #2d3436;">
              <span class="t">{{'COMMON.RESULTS' | translate}}</span>
            </div>
            <a href="#" data-toggle="modal" data-target="#raceresultModal" class="btn btn-tertiary icon ml-2">
              <span class="icon icon-menu"></span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div (click)="video_clicked()" class="live btn mb-2">{{'COMMON.WATCH-LIVE-STREAM' | translate}}</div>

    <!-- 1st table -->
    <div class="race-preview shadow p-0 mb-2" *ngFor="let meeting of kironNewData; index as i">
      <div class="race-header bg-fill-secondary text-white">
        <div class="race-icon mr-2" style="margin:0 !important">
          <span class="icon"
            [ngClass]="[meeting.eventName.indexOf('Greyhound')!=-1 ? 'icon-greyhound':'icon-horse']"></span>
        </div>
        <div class="race-info">
          <div class="race-name text-uppercase">{{meeting.eventName}}</div>
          <div class="race-description text-uppercase">{{'COMMON.GAME' | translate}}: {{meeting?.eventCode}}</div>
        </div>
        <div class="race-extra">
          {{meeting.eventTime.substr(0,5)}}
          <span class="secondary">{{meeting.eventLocalDate}}</span>
        </div>
      </div>


      <div class="race-content">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let item of meeting.selections">
            <div class="avatar-wrapper">
              <div class="number">{{item.selectionNumber}}</div>
              <img src="{{'data:image/png;base64,'+item.jerseyIcon}}" alt="Wile" class="avatar">
            </div>
            <div class="info">
              <div class="title text-black" style="font-size: 17px;">{{item.name}}</div>
            </div>
            <div class="extra">
              <button disabled class="btn btn-tertiary">{{item.priceOdds.priceDecimal}}</button>
              <button (click)="setSPOdd(item)" [ngClass]="{'btn-tertiaryActive':item.clicked == true}"
                class="btn btn-tertiary">SP</button>
            </div>
          </li>
        </ul>
      </div>


      <!-- Modal -->
      <div class="modal fade" id="raceresultModal" data-backdrop="false" tabindex="100000" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="margin-left: 0px;margin-right: 0px;">
          <div class="modal-content" style="margin-top: 200px;margin-bottom: 100px;">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{'COMMON.RESULTS' | translate}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span style="font-size: 35px;" aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">


              <div *ngFor="let item of kironResults" class="race-preview shadow p-0 mb-2">
                <div class="race-header bg-fill-secondary text-white">
                  <div class="race-info">
                    <div class="race-name text-uppercase">{{item.eventName}}</div>
                    <div class="race-description text-uppercase">Game: {{item.eventCode}}</div>
                  </div>
                  <div class="race-extra">
                    {{item.eventTimeUTC.substr(11,5)}}
                    <span class="secondary">{{item.eventTimeUTC.substr(0,10)}}</span>
                  </div>
                </div>


                <div class="race-content">
                  <table class="racing-table table-borderless table-striped">
                    <thead>
                      <tr>
                        <th class="text-center">P</th>
                        <th>N</th>
                        <th class="text-left">Selection</th>
                        <th>Win</th>
                        <th>Place</th>
                      </tr>
                    </thead>
                    <tbody>

                      <tr class="won">
                        <td class="text-center">1</td>
                        <td>{{item.eventPositions[0].selectionNumber}}</td>
                        <td class="text-left">{{item.eventPositions[0].selectionName}}</td>
                        <td>{{item.eventPositions[0].winAmount}}</td>
                        <td>{{item.eventPositions[0].placeAmount}}</td>
                      </tr>

                      <tr class="">
                        <td class="text-center">1</td>
                        <td>{{item.eventPositions[1].selectionNumber}}</td>
                        <td class="text-left">{{item.eventPositions[1].selectionName}}</td>
                        <td>{{item.eventPositions[1].winAmount}}</td>
                        <td>{{item.eventPositions[1].placeAmount}}</td>
                      </tr>

                      <tr class="">
                        <td class="text-center">1</td>
                        <td>{{item.eventPositions[2].selectionNumber}}</td>
                        <td class="text-left">{{item.eventPositions[2].selectionName}}</td>
                        <td>{{item.eventPositions[2].winAmount}}</td>
                        <td>{{item.eventPositions[2].placeAmount}}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>

                <div class="race-footer">
                  <div class="d-flex">
                    <div class="d-flex flex-fill flex-column text-left">
                      <span class="t-faded t-small C_BK">Trifecta:</span>
                      <span class="t">{{item.tc}}</span>
                    </div>
                    <div class="d-flex flex-fill flex-column text-right">
                      <span class="t-faded t-small C_BK">Off Time:</span>
                      <span class="t">{{item.offTime}}</span>
                    </div>
                  </div>
                </div>


                <div class="race-footer">
                  <div class="d-flex">
                    <div class="d-flex flex-fill flex-column text-left">
                      <span class="t-faded t-small C_BK">Forecast:</span>
                      <span class="t">{{item.csf}}</span>
                    </div>
                    <div class="d-flex flex-fill flex-column text-right">
                      <span class="t-faded t-small C_BK">Quinella:</span>
                      <span class="t">{{item.qn}}</span>
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">{{'COMMON.CLOSE' | translate}}</button>
            </div>
          </div>
        </div>
      </div>